import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import {
  ParkingShiftDetailDto,
  ParkingShiftTableQuery,
  ParkingShiftTableResponseDto,
} from '../../../models/finance/parking-shift.model';

@Injectable({ providedIn: 'root' })
export class ApiParkingShiftService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  getParkingShiftsForTable(query: ParkingShiftTableQuery): Observable<ParkingShiftTableResponseDto> {
    const token = this.cookieService.get('token');
    const params: Record<string, string | number> = {
      siteId: query.siteId,
      page: query.page ?? 1,
      pageSize: query.pageSize ?? 20,
    };
    if (query.openDateFrom) params['openDateFrom'] = query.openDateFrom;
    if (query.openDateTo) params['openDateTo'] = query.openDateTo;
    if (query.status) params['status'] = query.status;

    return this.apiMethodService.request<ParkingShiftTableResponseDto>(
      '/Backoffice/getParkingShiftsForTable',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getParkingShiftsForTable',
        token,
        headerOnly: false,
        params,
      }
    );
  }

  getParkingShiftById(id: number, siteId: number): Observable<ParkingShiftDetailDto> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ParkingShiftDetailDto>(
      '/Backoffice/getParkingShiftById',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getParkingShiftById',
        token,
        headerOnly: false,
        params: { id, siteId },
      }
    );
  }
}
